import { render } from "./MusubiTabulator.vue?vue&type=template&id=58daedc0"
import script from "./MusubiTabulator.vue?vue&type=script&lang=js"
export * from "./MusubiTabulator.vue?vue&type=script&lang=js"

import "./MusubiTabulator.vue?vue&type=style&index=0&id=58daedc0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__